import React from "react"
import { Box, BoxProps, Theme } from "@carrotfertility/carotene-core"

type BorderedInfoTileProps = {
  children: React.ReactNode
  boxProps?: BoxProps
}

/**
 * A reusable info tile component with a primary accent border.
 */
export function BorderedInfoBox({ children, boxProps }: BorderedInfoTileProps): JSX.Element {
  return (
    <Box
      display="flex"
      padding={(theme: Theme) => theme.spacing(theme.tokens.spacing.lg)}
      border={(theme: Theme) => `1px solid ${theme.palette.primary.accent}`}
      borderRadius={(theme: Theme) => theme.tokens.borderRadius.md}
      {...boxProps}
    >
      {children}
    </Box>
  )
}
